module.exports = __webpack_public_path__ + "static/media/switch_account_youtube.b7b9047a.png";